module.exports = __webpack_public_path__ + "img/Login-Faemac.9b8e188f.jpg";